import {Component} from '@angular/core';
import {UserService} from '../services/user.service';
import {Publisher} from '../model/publisher.class';
import {ActivatedRoute, Router} from '@angular/router';
import {Media} from '../model/media.class';

@Component({
    selector: 'app-media-new',
    templateUrl: './media.new.component.html'
})
export class MediaNewComponent {

    public oidSteps = [10, 20, 50, 100, 200, 500, 750, 1000, 2000, 3000, 4000, 5000];
    public mediumTypes = ['Buch', 'Spiel', 'Lernmaterial', 'Archiv'];
    public constPublisher: Boolean = false;
    public publisher: Publisher;
    public publishers: Publisher[];
    public mid: number;
    public title: string;
    public author: string;
    public volume: number;
    public thumbMD5: string;
    public fileMD5: string;
    public isbn: string;
    public ean: string;
    public publishDate: Date;
    public articleNo: string;
    public shortDescribtion: string;
    public describtion: string;
    public mediaType = this.mediumTypes[0];
    public mediaStatus: string;
    public oidsPerUnit = this.oidSteps[3];

    public message = '';

    constructor(public userService: UserService, private route: ActivatedRoute, private router: Router) {
        this.userService.uploader.clearQueue();
        this.route.params.subscribe(
            (params) => {
                const id = params['id'];
                if (id !== '0') {
                    this.constPublisher = true;
                    userService.get(id, 'publisher').subscribe(data =>
                        this.publisher = data as Publisher
                    );
                } else {
                    // tslint:disable-next-line:max-line-length
                    userService.getPublishersWithout(userService.user.publisher.publisherId).subscribe(data => this.publishers = data as Publisher[]);
                }
            });
    }

    createMedia() {
        this.message = '';
        this.mediaStatus = this.userService.user.userType === this.userService.Admin
            ? this.userService.Approved : this.userService.New;
        // tslint:disable-next-line:max-line-length
        const media = new Media(this.mid, this.title, this.volume, this.author, null, null, null, 'en', this.isbn, this.ean, this.publishDate, new Date(), this.articleNo, this.shortDescribtion, this.describtion, this.mediaType, this.mediaStatus, 0, this.publisher, this.oidsPerUnit);
        if (media.publishDate === undefined || this.validateDate(media.publishDate)) {
            this.userService.create(media, 'media').subscribe(
                (data) => {
                    const actMedia = data as Media;
                    this.userService.uploadCover(actMedia).subscribe(
                        () => this.router.navigate(['/publisher/detail', actMedia.publisher.publisherId]),
                        (err) => this.message = 'Fehler beim Hochladen des Covers!');
                },
                (err) => {
                    this.message = 'Fehler beim Erstellen des Mediums: ' + err._body;
                });
        } else{
            this.message = 'Falsches Datumsformat!';
        }
    }

    validateDate(isoDate) {
        if (isNaN(Date.parse(isoDate))) {
            return false;
        } else {
            if (isoDate != (new Date(isoDate)).toISOString().substr(0, 10)) {
                return false;
            }
        }
        return true;
    }

}




// WEBPACK FOOTER //
// ./src/app/mediaNew/media.new.component.ts